function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 4c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1v1.5h14V4zM1 12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V7H1v5zm4.438-1.5h5.125a.439.439 0 010 .875H5.436A.439.439 0 015 10.937c0-.24.197-.437.438-.437zm-2.25 0h.374a.439.439 0 010 .875h-.374a.439.439 0 01-.438-.438c0-.24.197-.437.438-.437z"
});

function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
}

export default SvgCreditCard;